import productService from "../../../services/items/product.service";
import { productActionTypes } from "../../actionTypes/product.actionTypes";

export const addProduct = (productData) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_ADD_PRODUCT });
    const response = await productService.addProduct(productData);
    dispatch({
      type: productActionTypes.ADD_PRODUCT_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Add product error:", ex.message);
    dispatch({ type: productActionTypes.ADD_PRODUCT_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

export const updateProduct = (productData) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_UPDATE_PRODUCT });
    const response = await productService.updateProduct(productData);
    dispatch({
      type: productActionTypes.UPDATE_PRODUCT_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Update product error:", ex.message);
    dispatch({ type: productActionTypes.UPDATE_PRODUCT_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

export const deleteProduct = (productId) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_DELETE_PRODUCT });
    const response = await productService.deleteProduct(productId);
    dispatch({ type: productActionTypes.DELETE_PRODUCT_SUCCESS });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Delete product error:", ex.message);
    dispatch({ type: productActionTypes.DELETE_PRODUCT_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

export const getProductById = (productId) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_GET_PRODUCT });
    const response = await productService.getProductById(productId);
    dispatch({
      type: productActionTypes.GET_PRODUCT_SUCCESS,
      data: response.data.payload,
    });
    return response.data.payload; // Return server response
  } catch (ex) {
    console.error("Get product by ID error:", ex.message);
    dispatch({ type: productActionTypes.GET_PRODUCT_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

export const getItems = (queryParams) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_GET_PRODUCTS });
    const response = await productService.getItems(queryParams);
    dispatch({
      type: productActionTypes.GET_PRODUCTS_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Get products error:", ex.message);
    dispatch({ type: productActionTypes.GET_PRODUCTS_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

export const addProductImage =
  (productId, imageFile, isPrimary = false) =>
  async (dispatch) => {
    try {
      dispatch({ type: productActionTypes.START_ADD_PRODUCT_IMAGE });
      const response = await productService.addProductImage(productId, imageFile, isPrimary);
      dispatch({
        type: productActionTypes.ADD_PRODUCT_IMAGE_SUCCESS,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      dispatch({ type: productActionTypes.ADD_PRODUCT_IMAGE_FAILURE, error: error.response?.data });
      throw error.response?.data;
    }
  };

export const deleteProductImage = (productId, imageId) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_DELETE_PRODUCT_IMAGE });
    await productService.deleteProductImage(productId, imageId);
    dispatch({
      type: productActionTypes.DELETE_PRODUCT_IMAGE_SUCCESS,
      data: imageId,
    });
  } catch (error) {
    dispatch({ type: productActionTypes.DELETE_PRODUCT_IMAGE_FAILURE, error: error.response?.data });
    throw error.response?.data;
  }
};

export const setImageAsPrimary = (productId, imageId) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_SET_IMAGE_AS_PRIMARY });
    await productService.setImageAsPrimary(productId, imageId);
    dispatch({
      type: productActionTypes.SET_IMAGE_AS_PRIMARY_SUCCESS,
      data: imageId,
    });
  } catch (error) {
    dispatch({ type: productActionTypes.SET_IMAGE_AS_PRIMARY_FAILURE, error: error.response?.data });
    throw error.response?.data;
  }
};

export const updateItemExtension = (itemId, data) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_UPDATE_ITEM_EXTENSION });
    const response = await productService.updateItemExtension(itemId, data);
    dispatch({
      type: productActionTypes.UPDATE_ITEM_EXTENSION_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Update item extension error:", ex.message);
    dispatch({ type: productActionTypes.UPDATE_ITEM_EXTENSION_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

export const updateItemAttributesExtension = (itemId, itemAttributes) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_UPDATE_ITEM_ATTRIBUTES });
    const response = await productService.updateItemAttributesExtension(itemId, itemAttributes);
    dispatch({
      type: productActionTypes.UPDATE_ITEM_ATTRIBUTES_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Update item attributes error:", ex.message);
    dispatch({ type: productActionTypes.UPDATE_ITEM_ATTRIBUTES_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

export const updateItemRelatedItemsExtension = (itemId, relatedItems) => async (dispatch) => {
  try {
    dispatch({ type: productActionTypes.START_UPDATE_ITEM_RELATED_ITEMS });
    const response = await productService.updateItemRelatedItemsExtension(itemId, relatedItems);
    dispatch({
      type: productActionTypes.UPDATE_ITEM_RELATED_ITEMS_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Update related items error:", ex.message);
    dispatch({ type: productActionTypes.UPDATE_ITEM_RELATED_ITEMS_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

const productActions = {
  addProduct,
  updateProduct,
  deleteProduct,
  getProductById,
  getItems,
  addProductImage,
  deleteProductImage,
  setImageAsPrimary,
  updateItemExtension,
  updateItemAttributesExtension,
  updateItemRelatedItemsExtension,
};

export default productActions;
